export enum ContractListViewTypes {
  ToBeConfirmed = 0,
  Archived = 1,
  Future = 2,
}
